import { useTranslation } from "react-i18next";

import { CommonNavItemProps, NavItem } from "../parts/nav_item";

export const ProfilesNavItem = (props: CommonNavItemProps) => {
  const { t } = useTranslation("translation", { keyPrefix: "navBar.items" });
  return (
    <NavItem
      icon="profiles"
      isActiveTest={(path) => path.match(/^\/profiles/) && path !== "/profiles/me"}
      name={t("profiles")}
      href="/profiles"
      id="profiles"
      {...props}
    />
  );
};
